import { Pipe, PipeTransform } from '@angular/core';
import { Region, regionToLabel } from '../types';

@Pipe({
  name: 'regionToLabel',

})
export class RegionToLabelPipe implements PipeTransform {
  transform(region: Region): string {
    return regionToLabel(region);
  }
}
